import React, { Dispatch, SetStateAction } from 'react';

import './WpTabs.scss';

type Dispatcher<S> = Dispatch<SetStateAction<S>>;

export interface Props {
  // TODO (josh) : force children to WpTab only
  children?: React.ReactNode[];
  onTabClick?: Dispatcher<string>;
  activeTab?: string;
}

const WpTabs: React.FC<Props> = ({ onTabClick, activeTab, children }: Props) => {
  const handleTabClick = tab => {
    if (onTabClick) onTabClick(tab);
  };

  const newProps = {
    activeTab,
    onTabClick: handleTabClick,
  };

  return (
    <div className="WpTabs">
      {React.Children.map(children, (child: React.ReactElement<any>) => {
        if (!child) {
          return null;
        }
        return React.cloneElement(child, { ...child.props, ...newProps });
      })}
    </div>
  );
};

export default WpTabs;
